/**
 * BLU-1506: the Order Queue's "Waiting on blank (N)" button, after the manual
 * order buttons. It opens the Waiting on blank view in place (`?view=
 * waiting_blank`) and closes it again, so it is a toggle (aria-pressed), not
 * a link. Same amber family as "Awaiting artwork (N)" (QUEUE_ATTENTION_BUTTON_CLASS).
 *
 * The page renders it only for the floor's owner, and only while orders wait
 * or the view is open (so the way back never disappears under the reader).
 */
import { useTranslation } from 'react-i18next';
import { PackageSearch } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { QUEUE_ATTENTION_BUTTON_CLASS, QUEUE_ATTENTION_BUTTON_PRESSED_CLASS } from './orders/queue-attention-button';

interface WaitingOnBlankButtonProps {
  count: number;
  open: boolean;
  onToggle: () => void;
}

export function WaitingOnBlankButton({ count, open, onToggle }: WaitingOnBlankButtonProps) {
  const { t } = useTranslation('production');
  return (
    <Button
      type="button"
      variant="outline"
      aria-pressed={open}
      onClick={onToggle}
      className={cn(QUEUE_ATTENTION_BUTTON_CLASS, open && QUEUE_ATTENTION_BUTTON_PRESSED_CLASS)}
      data-testid="waiting-on-blank-button"
    >
      <PackageSearch className="h-4 w-4" aria-hidden="true" />
      {t('orders.waiting.button', { count })}
    </Button>
  );
}
